// assets/js/smooth-anchors.js

/**
 * Scroll fluide vers une ancre, avec gestion d'un offset (header sticky par ex.)
 */

const HEADER_SELECTOR = '.site-header'; // adapte au besoin
const DEFAULT_HEADER_HEIGHT = 130; 
const EXTRA_OFFSET = 16;

function getScrollOffset() {
  const header = document.querySelector(HEADER_SELECTOR);
  const headerHeight = header ? header.offsetHeight : DEFAULT_HEADER_HEIGHT;
  return headerHeight + EXTRA_OFFSET; // ≈ 146 px
}

function getTargetFromHash(hash) {
  if (!hash || hash === '#') return null;
  const id = hash.replace('#', '');
  return document.getElementById(id) || document.querySelector(`[name="${id}"]`);
}

function scrollToElement(el, { fromTop = false, smooth = true } = {}) {
  if (!el) return;

  const offset = getScrollOffset();
  const rect = el.getBoundingClientRect();
  const targetY = rect.top + window.pageYOffset - offset;

  if (fromTop) {
    // On force le départ tout en haut puis on déclenche le scroll fluide
    window.scrollTo(0, 0);
    // petit delay pour éviter un effet trop brutal
    window.setTimeout(() => {
      window.scrollTo({
        top: targetY,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }, 50);
  } else {
    window.scrollTo({
      top: targetY,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }
}

function handleHashChange(hash, { fromTop = false } = {}) {
  const target = getTargetFromHash(hash);
  if (!target) return;
  scrollToElement(target, { fromTop, smooth: true });
}

export function initSmoothAnchors() {
  const { location } = window;

  // 1) Gérer les ancres au clic (navigation interne dans la même page)
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="#"]');
    if (!link) return;

    const href = link.getAttribute('href') || '';
    if (href === '#' || href === '') return;

    // On ne gère ici que les ancres de la page courante :
    // - href="#section"
    // - href="/chemin/actuel/#section"
    try {
      const url = new URL(href, location.origin);

      const isSamePath = url.pathname === location.pathname;
      const hasHash = !!url.hash;

      if (isSamePath && hasHash) {
        event.preventDefault();

        // On met à jour l'URL sans recharger la page
        if (url.hash !== location.hash) {
          history.pushState(null, '', url.hash);
        }

        handleHashChange(url.hash, { fromTop: false });
      }
    } catch (err) {
      // Si new URL plante (href bizarre), on ne casse pas le lien
      return;
    }
  });

  // 2) Si la page charge déjà avec un hash (#ancre)
  //    → on repart du haut et on glisse vers l'ancre
  if (location.hash) {
    // On attend que la page soit vraiment prête (images, fonts…)
    window.addEventListener('load', () => {
      handleHashChange(location.hash, { fromTop: true });
    });
  }

  // Optionnel : si on change le hash sans reload (history.pushState ailleurs)
  window.addEventListener('hashchange', () => {
    handleHashChange(location.hash, { fromTop: false });
  });
}
